import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { CaretDown, CaretUp } from "phosphor-react";

import './AccordionItem.scss';

const AccordionItem = ({ id, type, name, children, onToggle, active, multiple, openbydefault, accordionItemClass }) => {
    const [visiblity, setVisiblity] = useState(openbydefault ? openbydefault : false);

    const isActive = multiple ? visiblity : active;

    const updateVisiblity = () => {
        setVisiblity(!visiblity);
        onToggle();
    };

    const getHeader = (type) => {
        switch (type) {
            case 'accordion-lg':
                return (
                    <div className='item-select-lg'>
                        <span className='lg-title'>
                            {name}
                        </span>
                        <span className='lg-caret'>
                            {isActive ?
                                <CaretUp size={16} weight="bold" data-testid={`${id}-caret-up`} />
                                : <CaretDown weight="bold" size={16} data-testid={`${id}-caret-down`} />}
                        </span>
                    </div>
                )
            default:
                return (
                    <div className='item-select-default' onClick={updateVisiblity} >
                        <span className='default-title'>
                            {name}
                        </span>
                        <span className='default-caret' data-testid={`${id}-caret`}>
                            {isActive ?
                                <CaretUp size={16} weight="bold" data-testid={`${id}-caret-up`} />
                                : <CaretDown weight="bold" size={16} data-testid={`${id}-caret-down`} />}
                        </span>
                    </div>
                )
        }
    }

    return (
        <li id={id} data-testid={id} className={`accordion-item ${accordionItemClass ? accordionItemClass : ''}`} onClick={updateVisiblity}>
            {getHeader(type)}
            {isActive &&
                <div className='accordion-content'>
                    {children}
                </div>
            }
        </li>
    )
}

AccordionItem.propTypes = {
    id: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    children: PropTypes.node,
    onToggle: PropTypes.func,
    active: PropTypes.bool,
    multiple: PropTypes.bool,
    openbydefault: PropTypes.bool,
    value: PropTypes.number,
    accordionItemClass: PropTypes.string
}

export default AccordionItem;